module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_14.234c08d1.jpeg";